export default "__VITE_ASSET__Db$NunsE__"